import {jsonp} from 'vue-jsonp'
import MapLoader from '@/libs/AMap.js'
import requestGet from '@/libsV2/request.js'
import storage from '@/libsV2/storage.js';
import alert from "element-ui/packages/alert";
import common from "@/libsV2/common";
import store from "@/store/store";
import defaultData from "@/libsV2/defaultData";

// 微信环境
const getWxsignJsonp = async (baseUrl, data) => {
    return new Promise((resolve, recject) => {
        jsonp(baseUrl, {
            callbackName: 'successCallback'
        }).then(res => {
            const wxConfigParams = res;
            console.log(res, 'wx cong');
            // const wxConfigParams = await requestGet.getData('wechat/api/getsign', { url: encodeURIComponent(window.location.href.split('#')[0]), agent: 0 })
            // console.log("wx签名>>>", wxConfigParams);
            wx.config({
                debug: false,
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature,// 必填，签名
                jsApiList: [
                    'onMenuShareAppMessage',
                    'onMenuShareTimeline',
                    'getLocation',
                    'startRecord',
                    'stopRecord',
                    'playVoice',
                    'uploadVoice',
                    'downloadVoice',
                    'openLocation',
                    'hideMenuItems'
                ], // 必填，需要使用的JS接口列表
                openTagList: ['wx-open-launch-weapp'],//h5跳转小程序
            });
            let oShare = {
                title: data.share_friend_title,
                desc: data.share_friend_desc,
                imgUrl: data.share_img_url,
                link: data.share_link,
            }
            wx.ready(() => {
                //分享给朋友
                wx.onMenuShareAppMessage({
                    ...oShare,
                    success: function () {
                        store.commit('editShowShareTips',false)
                    }
                });
                //分享朋友圈
                wx.onMenuShareTimeline({
                    ...oShare,
                    success: function () {
                    }
                });
                resolve(oShare)
                // wx.hideMenuItems({
                //     menuList: ["menuItem:share:timeline", "menuItem:favorite", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:share:QZone", "menuItem:share:facebook", "menuItem:originPage", "menuItem:openWithSafari", "menuItem:openWithQQBrowser"], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                // });
            })
            wx.error(err => {
                slsReport({
                    ...err,
                    ...wxConfigParams,
                    authUrl: baseUrl,
                })
                console.log('-->', JSON.stringify(res))
            })
        })
    })
}

// 企业微信环境
const getWxsign = (wxRes) => {
    return new Promise(async (resolve, reject) => {
        const wxConfigParams = await requestGet.getData('wechat/api/getsign', {
            url: encodeURIComponent(window.location.href.split('#')[0]),
            agent: 0
        })
        const appSignature = await requestGet.getData('wechat/api/getsign', {
            url: encodeURIComponent(window.location.href.split('#')[0]),
            agent: 1
        })
        // return new Promise((resolve, recject) => {
        //  console.log('企业微信签名', wxConfigParams)
        wx.config({
            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: wxConfigParams.data.data.result.signPackage.corpid, // 必填，企业微信的corpID
            timestamp: wxConfigParams.data.data.result.signPackage.timestamp, // 必填，生成签名的时间戳
            nonceStr: wxConfigParams.data.data.result.signPackage.noncestr, // 必填，生成签名的随机串
            signature: wxConfigParams.data.data.result.signPackage.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: ['shareAppMessage', 'getLocation', 'onMenuShareAppMessage', 'onMenuShareWechat', 'shareWechatMessage', 'openLocation', 'onMenuShareTimeline', 'hideMenuItems'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            openTagList: ['wx-open-launch-weapp'],//h5跳转小程序
        });
        wx.ready(() => {
            //   console.log('分享内容', wxRes)
            wx.onMenuShareAppMessage({
                title: wxRes.share_friend_title, // 分享标题
                desc: wxRes.share_friend_desc, // 分享描述
                imgUrl: wxRes.share_img_url, // 分享图标
                link: wxRes.share_link, // 分享链接；在微信上分享时，该链接的域名必须与企业某个应用的可信域名一致
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.onMenuShareTimeline({
                title: wxRes.share_friend_title,// 分享标题
                imgUrl: wxRes.share_img_url, // 分享链接；在微信上分享时，该链接的域名必须与企业某个应用的可信域名一致
                link: wxRes.share_link, // 分享图标
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.onMenuShareWechat({
                title: wxRes.share_friend_title, // 分享标题
                desc: wxRes.share_friend_desc, // 分享描述
                link: wxRes.share_link, // 分享链接
                imgUrl: wxRes.share_img_url, // 分享封面
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            //  console.log('应用签名', appSignature.data.data.result.signPackage)
            wx.agentConfig({
                corpid: appSignature.data.data.result.signPackage.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                agentid: appSignature.data.data.result.signPackage.agentid, // 必填，企业微信的应用id （e.g. 1000247）
                timestamp: appSignature.data.data.result.signPackage.timestamp, // 必填，生成签名的时间戳
                nonceStr: appSignature.data.data.result.signPackage.noncestr, // 必填，生成签名的随机串
                signature: appSignature.data.data.result.signPackage.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                jsApiList: ['getContext', 'sendChatMessage', 'hideMenuItems', 'launchMiniprogram', 'miniProgram'], //必填
                success: function (res) {
                    // 回调
                    console.log('企业', res)
                    // 如果需要使用返回值，需要改写为promise才能resolve(res)
                },
                fail: function (err) {
                    //  console.log('返回错误信息', err)
                    if (err.errMsg.indexOf("function not exist") > -1) {
                        alert("版本过低请升级");
                    }
                    slsReport({
                        ...err,
                        sdk_type:'agentConfig',
                        authUrl: 'wechat/api/getsign',
                        appSignature: appSignature.data.data.result.signPackage,
                    })
                },
            });
            resolve()
        })

        wx.error((err) => {
            slsReport({
                ...err,
                sdk_type:'config',
                authUrl: 'wechat/api/getsign',
                wxConfigParams: wxConfigParams.data.data.result.signPackage,
            })
            reject(err)
            //  console.log("-->", JSON.stringify(err));
        });
        // })
    })
}

// 获取wx sdk配置
export const getWxSingleConfig = (data = {}) => {
    let signUrl = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : `${window.location.origin}${window.location.pathname}${window.location.search}`;
    const obj = {url: encodeURIComponent(signUrl)}
    let baseUrl = ''
    if (process.env.VUE_APP_FLAG == 'production') {
        //正式环境
        baseUrl = `https://api.iwxapi.com/cmpt/client/jssign?source=h5&company_id=11&bcode=d41d8cd98f00b204e9800998ecf8427e&jsonp=1&url=${obj.url}`;
    } else {
        // 测试环境
        baseUrl = `https://api.iwxapi.com/cmpt/client/jssign?source=h5&company_id=20&bcode=f5ad873c89697f28764c2f02b0927b7&jsonp=1&url=${obj.url}`;
    }

    if (common.isWechat() == defaultData.weChat.wx) { // 微信
        return getWxsignJsonp(baseUrl, data)
    } else if (common.isWechat() == defaultData.weChat.wxWork) { // 企微
        return getWxsign(data)
    } else {
        return getWxsignJsonp(baseUrl, data)
    }
}

// 获取地理位置
export const wxGetLocationH5 = () => {
    return new Promise((resolve, reject) => {
        // wx.ready(() => {
        wx.getLocation({
            type: 'gcj02',
            isHighAccuracy: true,
            success(res) {
                console.log(res, '--->')
                const latitude = Number(res.latitude)
                const longitude = Number(res.longitude)
                geoGetAddress([longitude, latitude]).then(result => {
                    const resultInfo = result.regeocode.addressComponent;
                    resultInfo.latitude = latitude
                    resultInfo.longitude = longitude
                    resolve(resultInfo)
                }).catch(err => {
                    //  console.log(err, "错误")
                    reject(err)
                })
            },
            cancel(err) {
                slsReport(err)
            },
            fail(err) {
                slsReport(err)
                reject(err)
                console.log('定位报错', err)
            },
            complete(info) {
                if (info.errMsg == 'getLocation:cancel') {
                    reject(info)
                }
            }
        })
        // })
    })
}

// 正向地理位置编码
export const geoGetLocation = (addresText) => {
    return new Promise((resolve, reject) => {
        MapLoader().then(AMap => {
            AMap.plugin('AMap.Geocoder', function () {
                const geocoder = new AMap.Geocoder()
                geocoder.getLocation(addresText, function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        // result中对应详细地理坐标信息
                        resolve(result)
                    } else {
                        reject(result)
                    }
                })
            })
        })
    })
}

// 逆向地理位置编码
export const geoGetAddress = (arrLnglat) => {
    return new Promise((resolve, reject) => {
        MapLoader().then(AMap => {
            AMap.plugin('AMap.Geocoder', function () {
                const geocoder = new AMap.Geocoder()
                geocoder.getAddress(arrLnglat, function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        // result为对应的地理位置详细信息
                        resolve(result)
                    } else {
                        //  console.log("编码失败");
                        reject(result)
                    }
                })
            })
        })
    })
}

export async function wechatSharefund(columnInfo) {
    const data = await wechatConfig(location.href.split('#')[0]) // 返回的微信信息
    // console.log(data)
    if (data.code === 0) {
        // 注册
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.data.appId, // 必填，公众号的唯一标识
            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
            signature: data.data.signature, // 必填，签名
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'startRecord',
                'stopRecord',
                'playVoice',
                'onVoiceRecordEnd',
                'uploadVoice',
                'onVoicePlayEnd',
                'downloadVoice'
            ] // 必填，需要使用的JS接口列表
        })
        // 是否成功
        wx.ready(function (res) {
            //  console.log([res, 90])
            wx.updateAppMessageShareData({
                title: '我是自定义首页！！！！！好友' + store.getters.doctorId,
                desc: '自定义描述', // 分享描述
                link: 'https://doctor.taiori.com/doctor/hospitalIndex?userParam=' + store.getters.doctorId,
                imgUrl: '', // 分享图标
                success: function () {
                    // 设置成功
                }
            })
            wx.updateTimelineShareData({
                title: "我是自定义首页！！圈" + store.getters.doctorId,
                link: 'https://doctor.taiori.com/doctor/hospitalIndex?userParam=' + store.getters.doctorId,
                imgUrl: '',
                success: function () {
                }
            });

        });
        // 是否支持指定JS接口
        wx.checkJsApi({
            jsApiList: ['startRecord'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
                //   console.log([res, '114'])
                store.commit('jsApiList', res)
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
        })
        wx.error(function (res) {
            //  console.log(res)
        })
    }
}

// sls上报
function slsReport(err) {
    console.log(err,'slsReport')
    if (window.location.host != 'aosmithv2.iwxapi.com') {
        return
    }

    let param = "&type=2";
    param += "&url=" + encodeURIComponent(window.location.href);
    param += "&host=" + window.location.host;
    param += "&data=" + JSON.stringify(err || {});
    param += "&iswechat=" + common.isWechat();
    let errURL = "https://web-error.cn-beijing.log.aliyuncs.com/logstores/aosmith-h5/track_ua.gif?APIVersion=0.6.0" + param;
    let logstores = new Image()
    logstores.src = errURL;
    logstores = null
}
